import { useState } from 'react';

export const useFileDownload = () => {
  const [hasDownloadError, setHasDownloadError] = useState(false);

  const handleDownload = async (url: string, filename: string) => {
    try {
      setHasDownloadError(false);
      const response = await fetch(url);

      if (!response.ok) {
        setHasDownloadError(true);
        return;
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch {
      setHasDownloadError(true);
    }
  };

  return { hasDownloadError, handleDownload };
};
